import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { processStateEnumProvider, processTypeEnumProvider, TransactionTransferTypeEnumProvider } from "../processStateEnumProvider";
import { PaymentRequestsListViewModel, singlePaymentRequest } from "./paymentRequestsList-viewModel"

export class PaymentRequestsListView extends View<PaymentRequestsListViewModel>{
    GetViewUniqueId(): string {
        return "V-8B1933A0-AC8A-47C9-B376-CA0B8A17B93B"
    }
    loadHtml(): string {
        let element = require('./paymentRequestsList.html').default;
        let style = require('./paymentRequestsList.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set paymentRequests(v: ObservableArray<singlePaymentRequest>) { this._paymentRequests = v; } public get paymentRequests(): ObservableArray<singlePaymentRequest> { return this._paymentRequests;} private _paymentRequests: ObservableArray<singlePaymentRequest>;
    public set stateEnumProvider(v: processStateEnumProvider) { this._stateEnumProvider = v; } public get stateEnumProvider(): processStateEnumProvider { return this._stateEnumProvider;} private _stateEnumProvider: processStateEnumProvider;
    public set typeEnumProvider(v: processTypeEnumProvider) { this._typeEnumProvider = v; } public get typeEnumProvider(): processTypeEnumProvider { return this._typeEnumProvider;} private _typeEnumProvider: processTypeEnumProvider;
    public set transactionTypeEnumProvider(v: TransactionTransferTypeEnumProvider) { this._transactionTypeEnumProvider = v; } public get transactionTypeEnumProvider(): TransactionTransferTypeEnumProvider { return this._transactionTypeEnumProvider;} private _transactionTypeEnumProvider: TransactionTransferTypeEnumProvider;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    createNewRequest(){
        this.dataContext.createNewRequest();
    }
}
